class KomfyStickyBar extends HTMLElement {
  connectedCallback() {
    const targetId = this.dataset.target;
    const target = document.getElementById(targetId);
    if (!target) return;

    this.mobileQuery = window.matchMedia('(max-width: 749px)');

    this.observer = new IntersectionObserver(
      ([entry]) => {
        const scrolledPast = entry.boundingClientRect.top < 0;
        const show = this.mobileQuery.matches
          ? !entry.isIntersecting && scrolledPast
          : !entry.isIntersecting;

        this.classList.toggle('komfy-sticky-bar--visible', show);
      },
      { threshold: 0 }
    );

    this.observer.observe(target);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('komfy-sticky-bar', KomfyStickyBar);
